import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  resetPage: {
    position: 'relative',
    height: 290,
  },
  positionRelative: {
    position: 'relative',
  },
  overflowHidden: {
    overflow: 'hidden',
  },
  personWithRocket: {
    display: 'none',
  },
  magnifyingGlass: {
    height: 249,
    right: -10,
    bottom: 35,
  },
  figuresLock: {
    height: 215,
    bottom: 35,
    right: -40,
  },
  circleOne: { display: 'none' },
  circleTwo: { display: 'none' },
  circleThree: { display: 'none' },
  circleFour: {
    width: 358,
    height: 358,
    right: -162,
    bottom: -68,
  },
  wrapper: {
    minHeight: '100vh',
    position: 'relative',
  },
  innerContainer: {
    width: '100%',
    margin: '0 auto',
  },
  linkBack: {
    display: 'inline-block',
    color: theme.palette.text.disabled,
    marginTop: 40,
  },
  signWith: {
    color: theme.palette.text.disabled,
    textAlign: 'center',
    margin: '35px 0',
    position: 'relative',
    '&:before': {
      content: '""',
      display: 'block',
      width: 'calc(50% - 46px)',
      height: 1,
      backgroundColor: theme.palette.info.light,
      left: 0,
      top: '50%',
      position: 'absolute',
    },
    '&:after': {
      content: '""',
      display: 'block',
      width: 'calc(50% - 46px)',
      height: 1,
      backgroundColor: theme.palette.info.light,
      right: 0,
      top: '50%',
      position: 'absolute',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginBottom: 35,
  },
  socialSignInButton: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    padding: '15px 40px',
    borderWidth: 1,
    borderColor: theme.palette.info.light,
    borderStyle: 'solid',
    borderRadius: 16,
    width: '100%',
    color: '#3B5998',
    '&:last-child': {
      marginLeft: 15,
    },
    '& i': {
      fontSize: 24,
    },
    '& svg': {
      height: 24,
      width: 24,
    },
  },
  [theme.breakpoints.up('sm')]: {
    resetPage: {
      position: 'absolute',
      height: '100%',
    },
    signUpWrapper: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      columnGap: 30,
    },
    popup: {
      order: 1,
      maxWidth: 330,
      justifySelf: 'flex-end',
    },
    personWithRocket: {
      display: 'block',
      height: 526,
      top: '50%',
      right: -11,
      transform: 'translateY(-50%)',
      objectFit: 'cover',
    },
    magnifyingGlass: {
      height: 383,
      right: -150,
      top: '50%',
      transform: 'translateY(-50%)',
    },
    figuresLock: {
      height: 386,
      top: '50%',
      right: -220,
      transform: 'translateY(-50%)',
    },
    circleOne: {
      display: 'block',
      width: 1126,
      height: 1126,
      right: '-905px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    circleTwo: {
      display: 'block',
      width: 40,
      height: 40,
      left: '-60px',
      top: 164,
    },
    circleThree: {
      display: 'block',
      width: 205,
      height: 205,
      top: 859,
      left: '-149px',
    },
    circleFour: {
      display: 'none',
    },
    wrapper: {
      display: 'grid',
      gridTemplateRows: '1fr auto 1fr',
    },
    innerContainer: {
      alignSelf: 'center',
      margin: 0,
      maxWidth: 330,
    },
  },
  [theme.breakpoints.up('md')]: {
    personWithRocket: {
      right: -47,
    },
    circleTwo: {
      left: '-147px',
    },
    circleThree: {
      height: 176,
      width: 176,
      left: '-238px',
      top: 630,
    },
    innerContainer: { maxWidth: 370 },
    popup: {
      maxWidth: 370,
    },
    figuresLock: {
      right: -212,
    },
  },
  [theme.breakpoints.up('lg')]: {
    personWithRocket: {
      right: 64,
    },
    magnifyingGlass: {
      height: 450,
      right: -60,
    },
    figuresLock: {
      width: 634,
      right: -180,
    },
    circleOne: {
      right: '-833px',
    },
    circleTwo: {
      left: '-88px',
      top: 163,
    },
    circleThree: {
      height: 230,
      width: 230,
      top: 717,
      left: '-391px',
    },
    innerContainer: {
      maxWidth: 350,
    },
    popup: {
      maxWidth: 350,
    },
    signWith: {
      margin: '50px 0',
    },
  },
}));

export default useStyles;
